export interface idNameItem {
  id: string;
  name: string;
  ps1?: string;
}

export const qbeCompare: idNameItem[] = [
  { id: '=', name: '等於', ps1: ' = ' },
  { id: '<', name: '小於', ps1: ' < ' },
  { id: '<=', name: '小於等於', ps1: ' <= ' },
  { id: '>=', name: '大於等於', ps1: ' >= ' },
  { id: '>', name: '大於', ps1: ' > ' },
  { id: 'like%', name: '前包含', ps1: ' like% ' },
  { id: '%like%', name: '其中包含', ps1: ' %like% ' },
  { id: '%like', name: '後包含', ps1: ' %like ' },
  { id: 'IN', name: '列舉 格式:(\'A\',\'B\',\'C\')', ps1: ' IN ' },
];
